import { Button, DialogActions, DialogTitle } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import { WorkspaceUserRole } from "common/interfaces";
import WorkspaceController, { WorkspaceControllerState } from "js/controllers/WorkspaceController";
import { UserProfile } from "js/react/components/Avatar";
import { BeautifulDialog, DialogContent } from "js/react/components/Dialogs/BaseDialog";
import { t } from "js/i18n";

const ProfilesContainer = styled.div`
    margin-top: 20px;
    display: grid;
    grid-gap: 10px;
    grid-template-columns: 1fr 1fr;
`;

const TextContainer = styled.p`
    letter-spacing: .1px;
`;

const LockedSharedSlideDialog = WorkspaceController.withInitializedState(
    function LockedSharedSlideDialog(props: WorkspaceControllerState & { closeDialog: () => void }) {
        const { closeDialog, users, userGroups } = props;
        const owners = users.filter(user => user.role === WorkspaceUserRole.OWNER);
        const librarians = users.filter(user => user.role === WorkspaceUserRole.LIBRARIAN);

        return (
            <BeautifulDialog closeDialog={closeDialog} >
                <DialogTitle>{t("Sorry, you don't have permission to edit this Shared Slide.")}</DialogTitle>
                <DialogContent>
                    <TextContainer>{t("This is a Shared Slide and its content is only editable by Owners and Librarians in your team. These are the members who have editing permissions.")}</TextContainer>
                    <ProfilesContainer>
                        {[...owners, ...librarians].map(user => (
                            <UserProfile
                                key={user.uid}
                                profile={user}
                            />
                        ))}
                    </ProfilesContainer>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={closeDialog} >
                        {t("Got It")}
                    </Button>
                </DialogActions>
            </BeautifulDialog >
        );
    }
);

export default LockedSharedSlideDialog;
